import { data, user } from 'services';
import { getShortName, getCategoryById, getVehicleClassById, getDate } from 'services/types';
import { ParkingCell } from 'libs/ui';
import { ChangeTypeSetForm, PrivilegedSetForm, DelSetForm, StatusSetForm, TariffSetForm, DateSetForm, ClassSetForm, CategorySetForm } from 'libs/forms';

export const getTableParams = (t, clientId) => {
  const setRight = user.haveRight('scard.bulk');
  const setActions = setRight
    ? [
        {
          title: 'Удалить',
          key: 'del',
          form: DelSetForm,
          simple: true,
          method: 'csc.bulk_delete',
          idsParam: 'ids',
          isDanger: true,
        },
        {
          title: 'Статус',
          key: 'status',
          form: StatusSetForm,
          dict: 'rfid.status',
          dictExclude: ['blocked_by_client'],
          simple: false,
          method: 'csc.bulk_change_status',
          idsParam: 'ids',
        },
        {
          title: 'Тариф',
          key: 'tariff',
          form: TariffSetForm,
          dict: 'rfid.status',
          simple: false,
          method: 'csc.bulk_update_tariff',
          idsParam: 'ids',
        },
        {
          title: 'Категория',
          key: 'tscategory',
          form: CategorySetForm,
          simple: false,
          method: 'csc.bulk_change_vehicle_category',
          idsParam: 'ids',
        },
        {
          title: 'Класс ТС',
          key: 'tsclass',
          form: ClassSetForm,
          simple: false,
          method: 'csc.bulk_change_vehicle_class',
          idsParam: 'ids',
        },
        {
          title: 'Действует по',
          key: 'dateto',
          form: DateSetForm,
          simple: false,
          method: 'csc.bulk_change_end_at',
          idsParam: 'ids',
        },
        {
          title: 'Свободный проезд',
          key: 'privileged',
          form: PrivilegedSetForm,
          simple: false,
          method: 'csc.bulk_change_is_privileged',
          idsParam: 'ids',
        },
        {
          title: 'Перенести в Абонементы',
          key: 'privileged',
          form: ChangeTypeSetForm,
          simple: true,
          method: 'csc.bulk_change_mean_type',
          idsParam: 'ids',
        },
      ]
    : [];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  const getFields = (props) => {
    const fields = [
      { name: 'pan', title: t('sections.БСК'), width: 140, sortField: 'pan' },
      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 170, sortField: 'vehicle_plate' },
      {
        name: 'is_blocked',
        title: t('grid.Статус'),
        width: 155,
        sortField: 'status',
        render: (val) => data.getDictValue('payment_mean.status', val),
      },
      {
        name: 'start_at',
        title: t('form.Дата действия с'),
        width: 210,
        sortField: 'start_at',
        render: (val) => getDate(val),
      },
      {
        name: 'end_at',
        title: t('form.Дата действия по'),
        width: 210,
        sortField: 'end_at',
        render: (val) => getDate(val),
      },
      { name: 'name', title: t('form.Держатель'), sortField: 'name', render: (val) => getShortName(val) },
    ];

    if (!clientId) {
      fields.push({ name: 'client_name', title: t('form.Клиент'), width: 145 });
    }
    fields.push({
      name: 'vehicle_class',
      title: t('dict_filter.Класс ТС'),
      width: 160,
      sortField: 'vehicle_class',
      render: (val) => getVehicleClassById(val),
    });

    fields.push({
      name: 'category_id',
      title: t('form.Категория'),
      width: 185,
      sortField: 'category_id',
      render: (val) => getCategoryById(val),
    });

    fields.push({ name: 'is_privileged', title: t('form.Свободный проезд'), width: 140, sortField: 'is_privileged', render: (val) => (val ? t('grid.Да') : t('grid.Нет')) });
    fields.push({ name: 'comment', title: t('filter.Комментарий'), width: 205 });

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 140,
      });
    }

    return fields;
  };

  return { getFields, getRowClass, withComment: true, setActions };
};
